// ABOUTME: Auth guard component that redirects unauthenticated users to the home page.
// ABOUTME: Renders nothing while Clerk's auth state is still loading.
import { useAuth } from '@clerk/react'
import { Navigate } from 'react-router'

interface Props {
  children: React.ReactNode
}

export function ProtectedRoute({ children }: Props) {
  const { isLoaded, isSignedIn } = useAuth()

  if (!isLoaded) return null
  if (!isSignedIn) return <Navigate to="/" replace />

  return <>{children}</>
}
